import { Feature } from 'src/.generated/Feature.EnterpriseWeb.model';
import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { useTheme } from 'lib/context/ThemeContext';

import classNames from 'classnames';
import Component from 'src/helpers/Component/Component';
import { ARProductCardTheme } from './ARProductCard.theme';
import ImageWrapper from 'src/helpers/Media/ImageWrapper';
import ARProductModal from 'src/helpers/Modals/ARProductModal';
import { getEnum } from 'lib/utils/get-enum';
import SvgIcon, { IconTypes } from 'src/helpers/SvgIcon/SvgIcon';

export type ARProductCardProps = Feature.EnterpriseWeb.RenewalByAndersen.Cards.ARProductCard;

const ARProductCard = (props: ARProductCardProps): JSX.Element | null => {
  const { fields } = props;
  const { themeData } = useTheme(ARProductCardTheme);
  const _icon = getEnum<IconTypes>(fields?.buttonIcon);
  const modalId = 'arProductModal_' + fields?.productName?.value.replaceAll(' ', '');

  if (!fields || !fields.productImageThumbnail?.value?.src) {
    return null;
  }

  const { productName, productImageThumbnail } = fields;

  const handleOpen = () => {
    const arModalElement = document.getElementById(modalId);
    arModalElement?.classList.toggle('hidden');
  };

  const viewInARBtn = (btnClasses: string) => {
    return (
      <>
        <div>
          <div
            className={classNames(
              'mt-s items-center justify-center',
              'flex items-start md:flex-row md:items-center'
            )}
          >
            {fields?.buttonText && (
              <div
                className={classNames(
                  'mt-s items-center justify-center',
                  'mb-s flex items-start md:flex-row md:items-center md:space-x-4'
                )}
              >
                <button
                  onClick={() => {
                    handleOpen();
                  }}
                  className={classNames(
                    btnClasses,
                    'group relative mr-2 mr-m flex w-fit !w-full items-center justify-center p-s',
                    'font-serif text-button font-bold text-theme-btn-text md:!w-fit'
                  )}
                >
                  <span>{fields?.buttonText?.value}</span>
                  <SvgIcon
                    icon={_icon}
                    className={classNames(
                      'ml-xxs',
                      'ml-[10px] group-hover:text-theme-btn-primary-icon-hover group-disabled:text-dark-gray',
                      btnClasses === ' bg-dark-gray' ? 'text-gray' : ' text-theme-btn-primary-icon'
                    )}
                  />
                </button>
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  return (
    <Component dataComponent="card/arproductcard" variant="lg" {...props}>
      <div className={classNames(themeData.classes.cardWrapper)}>
        {productName?.value && (
          <h3 className={classNames(themeData.classes.headline)}>{productName?.value}</h3>
        )}
        <div className={classNames(themeData.classes.immageWrapper)}>
          <ImageWrapper
            image={productImageThumbnail}
            imageLayout="responsive"
            additionalDesktopClasses="max-w-full"
            additionalMobileClasses="max-w-full"
          ></ImageWrapper>
        </div>
        <ARProductModal modalId={modalId} {...props} />
        {viewInARBtn(
          ' bg-theme-btn-bg hover:bg-theme-btn-bg-hover hover:text-theme-btn-text-hover disabled:bg-gray disabled:text-dark-gray disabled:cursor-not-allowed'
        )}
      </div>
    </Component>
  );
};

export default withDatasourceCheck()<ARProductCardProps>(ARProductCard);
